import { render, staticRenderFns } from "./KeyboardShortcutInfo.vue?vue&type=template&id=c5f17d9a&scoped=true&"
import script from "./KeyboardShortcutInfo.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutInfo.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcutInfo.vue?vue&type=style&index=0&id=c5f17d9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f17d9a",
  null
  
)

export default component.exports